/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SpendBucket = {
  /**
   * Exact estimated cost at current PAYG list prices
   */
  costUsd: string;
  /**
   * Inclusive bucket boundary
   */
  from: Date;
  /**
   * Exact integer ordinary usage quantity as a decimal string
   */
  quantity: string;
  /**
   * Exclusive bucket boundary
   */
  to: Date;
};

/** @internal */
export const SpendBucket$inboundSchema: z.ZodMiniType<SpendBucket, unknown> = z
  .pipe(
    z.object({
      cost_usd: z.string(),
      from: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      quantity: z.string(),
      to: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "cost_usd": "costUsd",
      });
    }),
  );

export function spendBucketFromJSON(
  jsonString: string,
): SafeParseResult<SpendBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendBucket' from JSON`,
  );
}
